import { GoogleSignIn } from "@capawesome/capacitor-google-sign-in";

// Google bloquea el flujo de "Sign in with Google" (el widget/script web GSI)
// dentro de WebViews embebidos como el de Capacitor — por eso en la app nativa
// usamos este plugin, que abre el flujo nativo de Android (Credential Manager /
// Play Services) en vez del script https://accounts.google.com/gsi/client.
// El Client ID sigue siendo el mismo "Web client" (REACT_APP_GOOGLE_CLIENT_ID);
// lo que valida el paquete/huella SHA-1 de la app es el "Android client" que
// hay que crear aparte en Google Cloud Console, en el mismo proyecto.
let initPromise = null;

function ensureInit() {
  if (!initPromise) {
    initPromise = GoogleSignIn.initialize({
      clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    });
  }
  return initPromise;
}

export async function nativeGoogleSignIn() {
  await ensureInit();
  const result = await GoogleSignIn.signIn();
  return result.idToken;
}
